<div class="aside-logo" id="kt_aside_logo">
    <default-logo></default-logo>
</div>
